import React, { useRef, useState, useEffect } from "react";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Popover from "react-bootstrap/Popover";

export default function Condition({ condition, updatePage, updateConditionsFilter, closePatternDetails, extraStyle = '' }) {
    const conditionRef = useRef(); // Reference to the div
    const [popoverWidth, setPopoverWidth] = useState(200); // State to store the popover width

    // Effect to set the popover width after the component renders
    useEffect(() => {
        if (conditionRef.current) {
            const width = conditionRef.current.getBoundingClientRect().width;
            setPopoverWidth(width + 2); // Update popover width dynamically
        }
    }, []); // Run when the ref changes

    return (
        <OverlayTrigger
            trigger={["hover", "focus"]}
            placement='bottom'
            overlay={
                <Popover
                    id='condition-popover'
                    style={{
                        maxWidth: '100%',
                        width: popoverWidth,
                        minWidth: 200
                    }}
                >
                    <Popover.Title>
                        {condition.condition_title}
                    </Popover.Title>
                    <Popover.Content>
                        {condition.condition_description}
                    </Popover.Content>
                </Popover>
            }
        >
            <div
                key={"pattern-condition-" + condition.condition_id}
                id={"pattern-condition-" + condition.condition_id}
                className={`condition clickable ${extraStyle} truncate`}
                onClick={() => {
                    updateConditionsFilter && updateConditionsFilter([condition.condition_id]);
                    updatePage && updatePage(0);
                    closePatternDetails && closePatternDetails(null);
                }}
                ref={conditionRef} // Assign the ref here
            >
                <b>{condition.condition_title}</b> - {condition.condition_description}
            </div>
        </OverlayTrigger>
    );
}
